import React from 'react'
import { Route, Switch } from 'react-router-dom'

import { PacificaStockCheckForm } from './PacificaStockCheck'

export default () => {
    return {
        routes: [
            {
                path: '/test-harnesses',
                render: ({ match }) => (
                    <Switch>
                        <Route
                            path={`${match.url}/pacifica-stock-check`}
                            exact
                            component={PacificaStockCheckForm}
                        />
                    </Switch>
                ),
            },
        ],
    }
}
